const STORAGE_KEY = 'buydrop_viewer_device_id';

/** Stable per-browser id for listing view deduplication (POST /listings/:id/view). */
export function getViewerDeviceId(): string {
  if (typeof window === 'undefined' || !window.localStorage) {
    return '';
  }
  try {
    let id = localStorage.getItem(STORAGE_KEY)?.trim();
    if (id && id.length >= 8) return id;
    id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `web-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return '';
  }
}
